import { useEffect } from 'react';
import { useStory, type StoryOptions } from '../../hooks/useStory';
import { resetStoryBridge, storyBridge } from '../../story/storyBridge';

/**
 * Royal Road's story on the open slot (Phase 3, `road_story`). Draws nothing
 * in the page: the story is on the slot canvas. Mounted by App while the
 * story is on there; it connects App's spin and exit paths to the story.
 */
export function SlotStory(props: StoryOptions) {
  const story = useStory(props);
  storyBridge.onSpinLanded = story.onSpinLanded;
  storyBridge.onSlotIdle = story.onSlotIdle;
  storyBridge.beforeExit = story.beforeExit;
  storyBridge.busy = story.busy;
  // Browser tests read the canvas through this, in dev builds only.
  if (import.meta.env.DEV) (window as unknown as { __story?: unknown }).__story = { inspect: story.inspect };
  useEffect(() => () => resetStoryBridge(), []);
  return null;
}
